import React, { Component } from 'react';
import Header from './header/header';
import Image_File from '../Image_File';
import noImageAvailable from '../img/noImageAvailable330.png';

class Client extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
       let imgPath = 'https://mordorintelligence.com:81/mordorlabs';
        let      imgTpl  = Image_File.children[0].children.map((image, index) => {
                                            return (
                                                <div class="client_img">
                                                    <img src={imgPath+"/img/images_clients/"+image.path}  />
                                                </div>
                                            )
                            }),
            imgTpl1  = Image_File.children[1].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl2  = Image_File.children[2].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl3  = Image_File.children[3].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl4  = Image_File.children[4].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl5  = Image_File.children[5].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl6  = Image_File.children[6].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl7  = Image_File.children[7].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            }),
            imgTpl8  = Image_File.children[8].children.map((image, index) => {
                return (
                    <div class="client_img">
                        <img src={imgPath+"/img/images_clients/"+image.path}  />
                    </div>
                )
            })

        return (
            <div>
            <Header/>
                <section class="ovrfl btm_mrgn">
                <div class="container">
                    <div class="row breadcrumb text-center trght">
                        <div class="col-md-12">
                            <span><a href="/">Home</a></span> <i class="fa fa-angle-right"></i>
                            <span>Clients</span>
                        </div>
                    </div>
                    <div class="row pad_0">
                        <div class="client_width ">
                            {/*<div class="client_fstrow" data-toggle="modal" data-backdrop="static" data-target="#myModalc"><i class="fa fa-filter"></i> &nbsp;&nbsp;&nbsp; SORT BY INDUSTRY</div>*/}
                            <div class="clts_total"></div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="client_width">
                            {imgTpl}
                            {imgTpl1}
                            {imgTpl2}
                            {imgTpl3}
                            {imgTpl4}
                            {imgTpl5}
                            {imgTpl6}
                            {imgTpl7}
                            {imgTpl8}

                        </div>
                    </div>
                </div>
            </section>
            </div>
    );
    }


    }
    export default Client;


// WEBPACK FOOTER //
// ./src/clients/Client.js